import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import StyledButton from '../../components/StyledButton';

type ConfirmModalProps<T> = {
  isOkDisabled?: boolean | ((state: T | null) => boolean);
  onCancel?: Runnable;
  onOk: Consumer<T | null>;
  message?: string | React.ReactNode;
};

/**
 * 確認ダイアログフック
 */
export const useConfirmModal = <T extends object>() => {
  const [state, setState] = React.useState<T | null>(null);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleClose = () => {
    onClose();
    setState(null);
  };

  const handleOpen = (initialState?: T) => {
    setState(initialState || null);
    onOpen();
  };

  const ConfirmModal: React.FunctionComponent<ConfirmModalProps<T>> = (
    props
  ) => {
    return (
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>確認</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{props.message}</ModalBody>
          <ModalFooter justifyContent="space-evenly">
            <StyledButton
              onClick={props.onCancel || handleClose}
              colorScheme="gray"
            >
              キャンセル
            </StyledButton>
            <StyledButton
              isDisabled={
                typeof props.isOkDisabled === 'function'
                  ? props.isOkDisabled(state)
                  : props.isOkDisabled
              }
              onClick={() => {
                props.onOk(state);
                handleClose();
              }}
            >
              OK
            </StyledButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };

  return { ConfirmModal, onClose: handleClose, onOpen: handleOpen };
};
